import Axios from 'axios'
import {PickUpLocationUrls} from '../urls'
import  { GateUrls } from '../urls'
import router from '../../../router'

export default {
  get_all_pick_up_locations (context) {
    Axios.get(PickUpLocationUrls.getAllPick_up_locations).then(function (response) {
      context.commit('GET_ALL_PICK_UP_LOCATIONS', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_ALL_PICK_UP_LOCATIONS', data)
    })
  },
  get_deleted_pick_up_locations (context) {
    Axios.get(PickUpLocationUrls.getDeletedPick_up_locations).then(function (response) {
      context.commit('GET_DELETED_PICK_UP_LOCATIONS', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_DELETED_PICK_UP_LOCATIONS', data)
    })
  },
  get_pickuplocation (context, publicId) {
    Axios.get(PickUpLocationUrls.getPickuplocation + publicId).then(function (response) {
      context.commit('GET_PICKUPLOCATION', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_PICKUPLOCATION', data)
    })
  },
  post_pickuplocation (context, data) {
    Axios.post(PickUpLocationUrls.postPickuplocation, data).then(function (response) {
      context.dispatch('get_all_pick_up_locations')
    })
  },
  update_pickuplocation (context, data) {
    Axios.patch(PickUpLocationUrls.editPickuplocation, data).then(function (response) {
      context.dispatch('get_all_pick_up_locations')
    })
  },
  delete_pickuplocation (context, data) {
    Axios.patch(PickUpLocationUrls.deletePickuplocation, data).then(function (response) {
      context.dispatch('get_all_pick_up_locations')
    })
  },
  restore_pickuplocation (context, publicId) {
    Axios.get(PickUpLocationUrls.restorePickuplocation + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_PICK_UP_LOCATIONS', response.data)
      router.push({
        name: 'Module.Pick_up_locations'
      })
    })
  }
}
